import { createStyles } from 'antd-style'

import { EaBuildIcon } from '@eastcoal/icon/EaBuildIcon'
import { PageName } from '@eastcoal/shared/enums/PageName'

import { BrandCarousel } from '../../../components/BrandCarousel'
import { FloorBlock } from '../../../components/FloorBlock'
import bgImage from '../assets/brandBg.png'

const useStyles = createStyles(({ token }) => ({
  container: {
    backgroundImage: `url(${bgImage})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover'
  }
}))

export const BrandFloor = () => {
  const { styles } = useStyles()
  return (
    <FloorBlock
      icon={<EaBuildIcon />}
      title='合作伙伴'
      classNames={{
        body: styles.container
      }}
    >
      <BrandCarousel pageName={PageName.HOME} />
    </FloorBlock>
  )
}
